import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step8View from './Step8-view';
import {loadOptionsByDDType} from '../../actions/loadOptionsByDDType';
import types from '../../types';
import {ddTypes} from '../../constants/dropdownTypes';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {
  convertISOStringToDateWithTimezoneOffset,
  convertDateWithTimezoneOffsetToEpoch
} from '../../utils/forms/normalizeTime';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const today = new Date();
const defaultOtherJobs = [{
  fromDate: null,
  toDate: null,
  occupation: '',
}];

const Step8 = ({
                 submitStep,
                 regType,
                 payload,
                 language,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse,
               }) => {
  const {weeklyAverageWorkHours, freelanceStartDate, otherJobs, ...restPayload} = payload;
  const initialValues = {
    freelanceStartDate: (freelanceStartDate) ? convertISOStringToDateWithTimezoneOffset(freelanceStartDate) : today,
    weeklyAverageWorkHours: weeklyAverageWorkHours ? {value: weeklyAverageWorkHours} : '',
    monthlyAverageIncome: '',
    monthlyAverageIncomeIsNotSpecified: false,
    workedAsEmployee: false,
    otherJobs: otherJobs
      ? [
        otherJobs.map(otherJob => {
          const {occupation, fromDate, toDate} = otherJob;
          return {
            occupation: {value: occupation},
            fromDate: (fromDate) ? convertISOStringToDateWithTimezoneOffset(fromDate) : null,
            toDate: (toDate) ? convertISOStringToDateWithTimezoneOffset(toDate) : null,
          }
        })
      ]
      : defaultOtherJobs,
    ...restPayload,
  };

  const validate = values => {
    const {
      freelanceStartDate,
      weeklyAverageWorkHours,
      monthlyAverageIncome,
      monthlyAverageIncomeIsNotSpecified,
      workedAsEmployee,
      otherJobs
    } = values;
    let errors = {};
    const mandatoryFields = monthlyAverageIncomeIsNotSpecified
      ? {
        freelanceStartDate,
        weeklyAverageWorkHours,
      }
      : {
        freelanceStartDate,
        weeklyAverageWorkHours,
        monthlyAverageIncome,
      };

    errors = checkRequiredValues(mandatoryFields, errors);

    if (workedAsEmployee) {
      const otherJobsErrors = otherJobs
        .map(otherJob => {
          let otherJobErrors = {};
          otherJobErrors = checkRequiredValues(otherJob, otherJobErrors);

          return (Object.keys(otherJobErrors).length > 0) ? otherJobErrors : null;
        });

      errors = (otherJobsErrors.filter(Boolean).length > 0)
        ? {...errors, otherJobs: otherJobsErrors}
        : {...errors};
    }

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {
      freelanceStartDate,
      weeklyAverageWorkHours,
      monthlyAverageIncome,
      monthlyAverageIncomeIsNotSpecified,
      workedAsEmployee,
      otherJobs: rawJobs
    } = values;

    const otherJobs = workedAsEmployee
      ? rawJobs.map(job => {
        const {occupation, fromDate, toDate} = job;
        return {
          occupation: occupation.value,
          fromDate: convertDateWithTimezoneOffsetToEpoch(fromDate),
          toDate: convertDateWithTimezoneOffsetToEpoch(toDate),
        };
      })
      : defaultOtherJobs;

    submitStep({
      step: 8,
      data: {
        regType,
        freelanceStartDate: convertDateWithTimezoneOffsetToEpoch(freelanceStartDate),
        weeklyAverageWorkHours: weeklyAverageWorkHours.value,
        monthlyAverageIncome: monthlyAverageIncomeIsNotSpecified ? null : monthlyAverageIncome,
        monthlyAverageIncomeIsNotSpecified,
        otherJobs,
        prevCompletedStepSign
      },
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
        {
          step_number: 8,
          step_name_en: 'National insurance',
          step_name_he: formatMessage({id: 'step8.page.title', defaultMessage: ''}),
          regType
        }))
      .catch(err => console.log({err}));
  };

  const loadOptions = ddType => (inputValue, callback) => {
    loadOptionsByDDType({callback, language, ddType})
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({values, isValid, submitCount}) => (
        <Step8View
          loadOptions={{
            hours: loadOptions(ddTypes.weekAverageHoursItems),
            jobs: loadOptions(ddTypes.occupationItems)
          }}
          values={values}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step8.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  language: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func,
  uploadFile: PropTypes.func,
};

export default Step8;
